module.exports = __webpack_public_path__ + "static/media/notifications.de2cdb81.svg";